import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";

import * as componentTypes from "../../../constants/componentTypes";
import * as modules from "../../../constants/modules";
import * as resources from "../../../constants/resources";
import * as navigationActions from "../../../actions/navigationActions";
import * as changelogService from "../../../services/changelogService";
import * as modelHelper from "../../../helpers/modelHelper";

import Modal from "../generic/Modal";
import CloseButton from "../generic/CloseButton";

class ChangeLogModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            versionList: ["-"],
            selectedVersion: "-",
            fullChangelog: []
        };
    }

    handleCloseModalClick = () => {
        this.props.dispatchCloseChangeLogModalAction();
    };

    handleDebugModalClick = () => {
        this.props.dispatchOpenDebugModalAction();
    };

    handleLinkLockedClick = (event) => {
        this.props.dispatchOpenWebviewModalWithParams({
            link: event.target.dataset.link,
            title: event.target.dataset.title
        });
    };

    getLink = (link) => {
        if (this.props.loggedUser.canEdit(resources.FUNCTION_OPEN_BROWSER)) {
            return (
                <a key={link.link} href={link.link} target="_blank" rel="noopener noreferrer">
                    {link.title}
                </a>
            );
        }

        return (
            <span
                className="span-link"
                key={link.link}
                data-link={link.link}
                data-title={link.title}
                onClick={this.handleLinkLockedClick}
            >
                {link.title}
            </span>
        );
    };

    getLogLinks = (log) => {
        let activeLinks = [];

        let link;
        for (link of log.links) {
            activeLinks.push(this.getLink(link));
        }

        return activeLinks;
    };

    getLinksSection = (log) => {
        if (log !== undefined && log.links !== undefined) {
            if (log.links.length > 0) {
                return (
                    <dd className="changelog-links">
                        <strong>
                            {log.links.length === 1 ? translate("changelog.link") : translate("changelog.links")}:{" "}
                        </strong>
                        {this.getLogLinks(log)}
                    </dd>
                );
            }
        }

        return "";
    };

    renderChangelogLines = () => {
        let logs = this.state.fullChangelog;

        let lines = [];
        logs.forEach((log) => {
            if (this.state.selectedVersion !== "-" && log.version.indexOf(this.state.selectedVersion) !== 0) {
                return;
            }
            if (this.props.gammaSoftware) {
                lines.push(
                    <dl key={log.version}>
                        <dt className="color-primary">
                            <Translate value="changelog.version" /> {log.version}
                        </dt>
                        <dd>
                            <span dangerouslySetInnerHTML={{__html: log.message.global ? log.message.global : ""}} />
                        </dd>
                        <dd>
                            <span
                                dangerouslySetInnerHTML={{__html: log.message.intergamma ? log.message.intergamma : ""}}
                            />
                        </dd>
                        {this.getLinksSection(log)}
                        <dd className="color-grey">{log.date}</dd>
                    </dl>
                );
            } else {
                lines.push(
                    <dl key={log.version}>
                        <dt className="color-primary">
                            <Translate value="changelog.version" /> {log.version}
                        </dt>
                        <dd>
                            <span dangerouslySetInnerHTML={{__html: log.message.global ? log.message.global : ""}} />
                        </dd>
                        <dd>
                            <span dangerouslySetInnerHTML={{__html: log.message.redlike ? log.message.redlike : ""}} />
                        </dd>
                        {this.getLinksSection(log)}
                        <dd className="color-grey">{log.date}</dd>
                    </dl>
                );
            }
        });

        return lines;
    };

    componentDidMount() {
        const logs = changelogService.getAll();

        let versionList = ["-"];
        let shortVer = "";
        let v = [];
        logs.forEach((log) => {
            v = log.version.split(".");
            if (v.length > 2) {
                shortVer = v[0] + "." + v[1] + "." + v[2];
                if (!versionList.includes(shortVer)) {
                    versionList.push(shortVer);
                }
            }
        });

        this.setState({
            versionList: versionList,
            fullChangelog: logs
        });
    }

    handleFilterSelectVersionChange = (event) => {
        this.setState({
            selectedVersion: event.target.value
        });
    };

    getHeader = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <Translate value="changelog.changelog" />
                <span style={{cursor: "pointer"}} onDoubleClick={this.handleDebugModalClick}>
                    &nbsp;
                </span>
            </React.Fragment>
        );
    };

    getSubHeader = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <span>
                    <Translate value="changelog.versionFilter" />
                </span>
                :&nbsp;
                <select
                    className="input-dark name-select"
                    value={this.state.selectedVersion}
                    onChange={this.handleFilterSelectVersionChange}
                >
                    {this.state.versionList.map((item) => {
                        return (
                            <option key={item} value={item}>
                                {item === "-" ? translate("changelog.allVersion") : item}
                            </option>
                        );
                    })}
                </select>
            </React.Fragment>,
            "flex-end"
        );
    };

    getContent = () => {
        return modelHelper.buildModalSection(this.renderChangelogLines(), "flex-column slim-scroll");
    };

    getFooter = () => {
        return modelHelper.buildModalSection(<CloseButton onClick={this.handleCloseModalClick} />);
    };

    render() {
        return (
            <Modal
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={this.getHeader()}
                subHeader={this.getSubHeader()}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{
                    minWidth: "50%",
                    height: "70%"
                }}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        gammaSoftware: store.module.name === modules.MODULE_FRONTDESK || store.module.name === modules.MODULE_MACHINE,
        loggedUser: store.login.loggedUser
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseChangeLogModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.CHANGELOG_MODAL));
        },
        dispatchOpenDebugModalAction: () => {
            dispatch(navigationActions.openModal(componentTypes.MODAL_NO_TAB, componentTypes.DEBUG_MODAL));
        },
        dispatchOpenWebviewModalWithParams: (params) => {
            dispatch(
                navigationActions.openModalWithParams(componentTypes.MODAL_NO_TAB, componentTypes.WEBVIEW_MODAL, params)
            );
        }
    };
};

export default ChangeLogModal = connect(mapStoreToProps, mapDispatchToProps)(ChangeLogModal);
